import QuestionValue from "./QuestionValue";
import {toRoman} from "roman-numerals";

export default class QuestionValueRoman extends QuestionValue {
    constructor(value) {
        super(value);
    }

    toString() {
        return toRoman(this._value);
    }
}